
<ngx-spinner 
  bdColor = "rgba(0, 0, 0, 0.8)" 
  size = "medium" 
  color = "#fff" 
  type = "line-spin-clockwise-fade" 
  [fullScreen] = "true"
>
  <p style="color: white" > {{ 'LOADING' | translate }}... </p>
</ngx-spinner>

<h1 mat-dialog-title>{{ 'RESEARCHMENTRESULT' | translate }}</h1>
<mat-dialog-content>
  <div class="row">
    <div [ngClass]="{'comments': result?.evidences.length > 0, 'fullScreenComments' : result?.evidences.length === 0 }">
      <h6>{{ 'RESULT' | translate }}</h6>
      <div class="score">
          <span style="font-weight: bold;">{{ 'SEMAPHORE' | translate }}: </span> <span id="research-score"> 
          <mat-icon *ngIf="result?.scoreRisk === 10" style="color: rgb(0, 255, 0); text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px  1px 0 black, 1px  1px 0 black;">brightness_1</mat-icon>
          <mat-icon *ngIf="result?.scoreRisk === 20" style="color: rgba(255, 255, 0); text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px  1px 0 black, 1px  1px 0 black;">brightness_1</mat-icon>
          <mat-icon *ngIf="result?.scoreRisk === 30" style="color: rgb(255, 0, 0); text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px  1px 0 black, 1px  1px 0 black;">brightness_1</mat-icon>
          <mat-icon *ngIf="result?.scoreRisk === 40" style="color: gray; text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px  1px 0 black, 1px  1px 0 black;">brightness_1</mat-icon></span>
      </div>
      <p><span style="font-weight: bold;">{{ 'REQUEST' | translate }}: </span>{{ result?.serviceNumber }}</p>
      <p><span style="font-weight: bold;">{{ 'EXPIRATIONDATE' | translate }}: </span> {{ result?.expirationDate | date: 'dd/MM/yyyy' }}</p>
      <p><span style="font-weight: bold;">{{ 'NAME' | translate }}: </span> {{ result?.completeName }}</p>
      <p><span style="font-weight: bold;">{{ 'NATIONALID' | translate }}: </span>{{ result?.nationalId }}</p>
      <p><span style="font-weight: bold;">{{ 'DIVISION' | translate }}: </span>{{ result?.divisionName }}</p>
      <p><span style="font-weight: bold;">{{ 'COMPANY' | translate }}: </span>{{ result?.clientName }}</p>
      <p><span style="font-weight: bold;">{{ 'STATUS' | translate }}: </span>{{ result?.statusName | translate }}</p>
      <p><span style="font-weight: bold;">{{ 'COMMENTS' | translate }}: </span>{{ result?.comments === "" ? '-' :  result?.comments }}</p>
    </div>
  
    <div class="notes" *ngIf="result?.evidences.length > 0">
      <h6>{{ 'EVIDENCES' | translate }}</h6>
      <ul>
        <li *ngFor="let evidence of result?.evidences" class="evidence-item">
          {{ evidence?.description }}
          <button
            mat-icon-button
            *ngIf="evidence.evidenceImages?.length"
            (click)="openImageGallery(evidence)"
            matTooltip="{{ 'VIEWIMAGE' | translate }}"
            >
            <mat-icon>image</mat-icon>
          </button>
        </li>
      </ul>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button style="background-color: #870424; color: white;" (click)="downloadReport()">{{ 'DOWNLOADREPORT' | translate }}</button>
  <button mat-button style="background-color: #6c757d; color: white;" (click)="closeModal()">{{ 'CLOSE' | translate }}</button>
</mat-dialog-actions>
